import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import InformeHorasPorSociedadcreen from './screen';
import { InformesAdapter, InformeHorasPorSociedad } from '../../../../../infraestructure/persistence/rest/InformesAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';

const InformeSociedadesHorasContainer = () => {

	const api = new InformesAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();
	let [ dataInforme, setDataInforme ] = useState<InformeHorasPorSociedad[]>([]);
	let result: any;

	const getData = async (filtro:any) => {
		try {
			result = await api.ListarHorasPorSociedad(filtro);
			if(result.data && result.data!=="")
			{
				setDataInforme([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	return (
		<>
		<InformeHorasPorSociedadcreen
			data={dataInforme}
			handleFilter={getData}
		/>
		</>
	);
};

export default InformeSociedadesHorasContainer;
